(function () {
  if (window.__nestPredictiveSearchModernImages20260902) return;
  window.__nestPredictiveSearchModernImages20260902 = true;

  function getModernImageUrl(src, size) {
    if (!src || !/\.(?:webp|avif)(?:\?.*)?$/i.test(src)) return null;

    var dimensions = String(size || '').match(/^(\d+)?x(\d+)?/);
    if (!dimensions || (!dimensions[1] && !dimensions[2])) return src;

    try {
      var url = new URL(src, window.location.origin);
      if (dimensions[1]) url.searchParams.set('width', dimensions[1]);
      if (dimensions[2]) url.searchParams.set('height', dimensions[2]);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function patchImageHelper(images) {
    if (!images || typeof images.getSizedImageUrl !== 'function') return false;
    if (images.getSizedImageUrl.__nestModernImageFormats20260902) return true;

    var originalGetSizedImageUrl = images.getSizedImageUrl;

    images.getSizedImageUrl = function (src, size) {
      var result = originalGetSizedImageUrl.apply(this, arguments);
      return result || getModernImageUrl(src, size);
    };
    images.getSizedImageUrl.__nestModernImageFormats20260902 = true;
    return true;
  }

  function applyPatch() {
    var themePatched = patchImageHelper(window.theme && window.theme.Images);
    var shopifyPatched = patchImageHelper(window.Shopify && window.Shopify.Image);
    return themePatched || shopifyPatched;
  }

  if (!applyPatch()) {
    document.addEventListener('DOMContentLoaded', applyPatch, { once: true });
    window.setTimeout(applyPatch, 0);
  }
})();
